import InviteColleagues from './InviteColleagues';
export default InviteColleagues;